import { render, staticRenderFns } from "./versionsComparison.vue?vue&type=template&id=76f9624e&scoped=true"
import script from "./versionsComparison.vue?vue&type=script&lang=js"
export * from "./versionsComparison.vue?vue&type=script&lang=js"
import style0 from "./versionsComparison.vue?vue&type=style&index=0&id=76f9624e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f9624e",
  null
  
)

export default component.exports